import { types, successAction, mergeEntities } from "@authzsvc/api-lib";
import * as at from "../actions/types";

const initialState = [];

const groupMemberIdentitiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case successAction(types.GET_GROUP_MEMBER_IDENTITIES):
      const stateCopy = [...state];
      return mergeEntities([{ data: stateCopy }, action.payload]);
    case at.CLEAR_GROUPS_DETAILS:
      return [];
    case at.CLEAR_GROUP_IDENTITIES:
      return [];
    default:
      return state;
  }
};

export default groupMemberIdentitiesReducer;
